/**
 * Theme color configuration for shadcn/ui
 * Values are HSL format without the hsl() wrapper (e.g., "262 83% 58%")
 */
export interface ThemeColors {
  background: string;
  foreground: string;
  card: string;
  "card-foreground": string;
  popover: string;
  "popover-foreground": string;
  primary: string;
  "primary-foreground": string;
  secondary: string;
  "secondary-foreground": string;
  muted: string;
  "muted-foreground": string;
  accent: string;
  "accent-foreground": string;
  destructive: string;
  "destructive-foreground": string;
  border: string;
  input: string;
  ring: string;
  "chart-1": string;
  "chart-2": string;
  "chart-3": string;
  "chart-4": string;
  "chart-5": string;
}

/**
 * Complete theme configuration with light and dark variants
 */
export interface ThemeConfig {
  name: string;
  displayName: string;
  radius: string;
  light: ThemeColors;
  dark: ThemeColors;
}

/**
 * All color keys for iteration
 */
export const THEME_COLOR_KEYS: (keyof ThemeColors)[] = [
  "background",
  "foreground",
  "card",
  "card-foreground",
  "popover",
  "popover-foreground",
  "primary",
  "primary-foreground",
  "secondary",
  "secondary-foreground",
  "muted",
  "muted-foreground",
  "accent",
  "accent-foreground",
  "destructive",
  "destructive-foreground",
  "border",
  "input",
  "ring",
  "chart-1",
  "chart-2",
  "chart-3",
  "chart-4",
  "chart-5",
];

/**
 * Color groups for organized editing
 */
export const COLOR_GROUPS: { title: string; colors: (keyof ThemeColors)[] }[] =
  [
    {
      title: "Base",
      colors: ["background", "foreground"],
    },
    {
      title: "Primary",
      colors: ["primary", "primary-foreground"],
    },
    {
      title: "Secondary",
      colors: ["secondary", "secondary-foreground"],
    },
    {
      title: "Cards & Popovers",
      colors: ["card", "card-foreground", "popover", "popover-foreground"],
    },
    {
      title: "Muted & Accent",
      colors: ["muted", "muted-foreground", "accent", "accent-foreground"],
    },
    {
      title: "Destructive",
      colors: ["destructive", "destructive-foreground"],
    },
    {
      title: "Borders & Input",
      colors: ["border", "input", "ring"],
    },
    {
      title: "Charts",
      colors: ["chart-1", "chart-2", "chart-3", "chart-4", "chart-5"],
    },
  ];
